import React from 'react';
import styled from 'styled-components';
import { Flex, Text } from '../components';
import { Button, SecondaryButton } from '../styles';

const Container = styled(Flex)`
  width: 800px;
  @media (max-width: 1024px) {
    width: 100%;
  }
`;

const InfoContainer = styled(Container)`
  padding: 20px;
  font-size: 14px;
  color: #68728a;
  background-color: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  margin-top: 20px;
`;

function AuthorizationPage({
  companyName,
  onClickBack,
  onClickAuthorize,
  isSubmitting,
  saveDataError,
}) {
  return (
    <Flex column>
      <Text variant='title'>Almost done</Text>
      <InfoContainer>
        <Text>
          {`By selecting "Authorize", ${companyName} is hereby authorized to directly deposit your pay
            to the account(s) listed above. You certify that your account(s) allow these transactions,
            and agree that direct deposit transactions you authorize comply with all applicable laws.
            You also agree that you are either the account holder or have the authority of the account
            holder to authorize direct deposits into the named account(s). This authorization will
            remain in effect until you modify or cancel it in writing.`}
        </Text>
      </InfoContainer>

      <Container style={{ marginTop: '20px', justifyContent: 'end' }}>
        <SecondaryButton onClick={onClickBack} style={{ marginRight: '12px' }}>
          Back
        </SecondaryButton>
        <Button onClick={onClickAuthorize} loading={isSubmitting}>
          Authorize
        </Button>
      </Container>
      {saveDataError && (
        <Container justifyContent='flex-end' mt={1}>
          <Text color='red'>{saveDataError}</Text>
        </Container>
      )}
    </Flex>
  );
}

export default AuthorizationPage;
